import { useNavigate } from "react-router-dom"
import { useUI } from "providers/UIProvider"

import { Box, Flex, useMediaQuery } from "@chakra-ui/react"

import DashboardCard from "components/UI/organisms/DashboardCard"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"

const DashboardItems = () => {
  const navigate = useNavigate()
  const { userRole, isAdmin, laundry, laundryChangesCount } = useAppContext()

  const { T } = useUI()

  const [isLowerThan768] = useMediaQuery("(max-height: 768px)")

  const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole as IRoles)


  return (
    <Box mt={isLowerThan768 ? "100px" : "200px"}>
      <Flex
        mt={"109px"}
        alignItems={"center"}
        justifyContent={"center"}
        w={"100%"}
        gap={"60px"}
      >
        {[IRoles.QAPP_ADMIN, IRoles.WASHER_ADMIN].includes(userRole as IRoles) && (
          <DashboardCard
            onClick={() => navigate("/employees")}
            title={T("dashboard.employee")}
            boxshadow="primary"
            icon="users"
            width={"dashboard_card_width"}
            height={"dashboard_card_width"}
            bg={"white"}
            borderRadius={"ml"}
          />
        )}
        <DashboardCard
          onClick={() => navigate("/reservations")}
          title={T("dashboard.reservations")}
          boxshadow="primary"
          icon="new_qapp"
          width={"dashboard_card_width"}
          height={"dashboard_card_width"}
          bg={"white"}
          borderRadius={"ml"}
        />
        {[IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER, IRoles.WASHER_ADMIN].includes(userRole as IRoles) && (
          <DashboardCard
            onClick={() => navigate(`/${isQappUser ? "laundries" : `laundries/${laundry?.id}`}`)}
            title={isQappUser ? T("dashboard.laundries") : T("dashboard.laundry")}
            boxshadow="primary"
            icon="warehouse"
            width={"dashboard_card_width"}
            height={"dashboard_card_width"}
            bg={"white"}
            borderRadius={"ml"}
            withBadge={Boolean(isQappUser)}
            badgeValue={laundryChangesCount?.toString()}
          />
        )}
      </Flex>
      <Flex
        mt={"37px"}
        alignItems={"dashboard.center"}
        justifyContent={"center"}
        w={"100%"}
        gap={"60px"}
      >
        {[IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole as IRoles) && (
          <DashboardCard
            onClick={() => navigate("/transactions")}
            title={T("dashboard.transactions")}
            boxshadow="primary"
            icon="currency_exchange"
            width={"dashboard_card_width"}
            height={"dashboard_card_width"}
            bg={"white"}
            borderRadius={"ml"}
          />
        )}
        {[IRoles.QAPP_ADMIN, IRoles.WASHER_ADMIN, IRoles.CASHIER].includes(userRole as IRoles) && (
          <DashboardCard
            onClick={() => navigate("/reports")}
            title={T("dashboard.report")}
            boxshadow="primary"
            icon="trending_up"
            width={"dashboard_card_width"}
            height={"dashboard_card_width"}
            bg={"white"}
            borderRadius={"ml"}
          />
        )}
        {isAdmin && (
          <DashboardCard
            onClick={() => navigate("/settings")}
            title={T("dashboard.settings")}
            boxshadow="primary"
            icon="settings"
            width={"dashboard_card_width"}
            height={"dashboard_card_width"}
            bg={"white"}
            borderRadius={"ml"}
          />
        )}
        {[IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole as IRoles) && (
          <DashboardCard
            onClick={() => navigate("/customers")}
            title={T("dashboard.customers")}
            boxshadow="primary"
            icon="user"
            width={"dashboard_card_width"}
            height={"dashboard_card_width"}
            bg={"white"}
            borderRadius={"ml"}
          />
        )}
      </Flex>
    </Box>
  )
}
export default DashboardItems
